import { render, staticRenderFns } from "./formulsFractionSimple.vue?vue&type=template&id=588368f8&scoped=true"
import script from "./formulsFractionSimple.vue?vue&type=script&lang=js"
export * from "./formulsFractionSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588368f8",
  null
  
)

export default component.exports